module.exports = __webpack_public_path__ + "img/bell_6.0359fb48.jpg";